import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

import { HistoriqueModel } from 'src/app/models/historique/historique.model';
import { HistoriqueService } from 'src/app/services/historique.service';
import { UsersService } from 'src/app/services/users.service';
import { GumOrganizationsService } from 'src/app/services/gumservices/gum-organizations.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-historique',
  standalone: true,
  templateUrl: './historique.component.html',
  styleUrls: ['./historique.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatTooltipModule,
    MatPaginator,
    MatSort,
  ],
})
export class HistoriqueComponent implements OnInit, OnDestroy {
  dataSource = new MatTableDataSource<HistoriqueModel>();
  displayedColumns: string[] = ['date', 'auteurNom', 'nature', 'description'];
  loading = false;

  uidToUser: Map<string, string> = new Map();
  orgChangeSub!: Subscription;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private historiqueService: HistoriqueService,
    private usersService: UsersService,
    private organizationsService: GumOrganizationsService
  ) {}

  ngOnInit(): void {
    const currentOrg = this.organizationsService.getCurrentOrganization();
    if (currentOrg?.id) {
      this.loadHistorique(currentOrg.id);
    }

    this.orgChangeSub =
      this.organizationsService.currentOrganizationChange$.subscribe((org) => {
        if (org?.id) {
          this.loadHistorique(org.id);
        }
      });
  }

  ngOnDestroy(): void {
    this.orgChangeSub?.unsubscribe();
  }

  loadHistorique(orgId: string): void {
    this.loading = true;
    this.uidToUser.clear();

    this.usersService.getUsers().subscribe({
      next: (users) => {
        users.forEach((u) => this.uidToUser.set(u.id, u.display));

        this.historiqueService.getByEntreprise(orgId).subscribe({
          next: (data) => {
            const sorted = (data ?? [])
              .map((h) => ({
                ...h,
                auteurNom: this.uidToUser.get(h.uidObject ?? '') || 'Système',
              }))
              .sort(
                (a, b) =>
                  new Date(b.dateHistorique!).getTime() -
                  new Date(a.dateHistorique!).getTime()
              );

            this.dataSource.data = sorted;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;

            this.loading = false;
          },
          error: (err) => {
            console.error('Erreur chargement historique', err);
            this.loading = false;
          },
        });
      },
      error: (err) => {
        console.error('Erreur chargement utilisateurs', err);
        this.loading = false;
      },
    });
  }

  getNatureIcon(nature: string): string {
    switch (nature.toLowerCase()) {
      case 'create':
        return 'add_circle';
      case 'update':
        return 'edit';
      case 'delete':
        return 'delete';
      case 'notice':
        return 'info';
      default:
        return 'help';
    }
  }
}
